import React from 'react'
import { Trash2 } from 'lucide-react'
import Modal from '@/components/Modal'
import { useLanguage } from '@/contexts/LanguageContext'
import type { useTurbineDetailViewModel } from '../useTurbineDetailViewModel'

type VM = ReturnType<typeof useTurbineDetailViewModel>

interface DeleteConfirmModalProps {
  deleteModal: VM['deleteModal']
  closeDeleteModal: VM['closeDeleteModal']
  confirmDeletePhoto: VM['confirmDeletePhoto']
  deleteError: VM['deleteError']
  setDeleteError: VM['setDeleteError']
  isDeletingPhoto: VM['isDeletingPhoto']
}

/**
 * Fotograf silme onayi.
 *
 * Ortak `Modal` tabanina tasindi: hata slotu (`error`) modalin ICINDE oldugu icin
 * silme basarisiz oldugunda mesaj kullanicinin baktigi yuzeyde kalir. Onceden bu
 * modal kendi overlay'ini yaziyordu ve silme hatasi yalnizca arka planda,
 * backdrop'un ALTINDA gorunmeyen bir bildirimle veriliyordu.
 */
const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  deleteModal,
  closeDeleteModal,
  confirmDeletePhoto,
  deleteError,
  setDeleteError,
  isDeletingPhoto,
}) => {
  const { t } = useLanguage()

  const photoName =
    deleteModal.photo?.originalName || deleteModal.photo?.key || 'İsimsiz Fotoğraf'

  return (
    <Modal
      isOpen={deleteModal.isOpen && deleteModal.photo !== null}
      onClose={closeDeleteModal}
      title="Fotoğrafı Sil"
      error={deleteError}
      onDismissError={() => setDeleteError(null)}
      isSubmitting={isDeletingPhoto}
      size="sm"
      footer={
        <div className="flex space-x-3 justify-end">
          <button
            type="button"
            onClick={closeDeleteModal}
            disabled={isDeletingPhoto}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium disabled:opacity-40 disabled:cursor-not-allowed"
          >
            İptal
          </button>
          <button
            type="button"
            onClick={confirmDeletePhoto}
            disabled={isDeletingPhoto}
            className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {/* Kural 10: istek ucustayken buton kilitli, cift silme istegi gitmez. */}
            {/* TODO(i18n): "Siliniyor..." icin strings.ts'te anahtar yok. */}
            {isDeletingPhoto ? 'Siliniyor...' : t.common.delete}
          </button>
        </div>
      }
    >
      <div className="flex items-start">
        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
          <Trash2 className="w-5 h-5 text-red-600" />
        </div>
        <p className="text-gray-600">
          <span className="font-medium">"{photoName}"</span>
          {' '}silinecek. Bu işlem geri alınamaz. Emin misiniz?
        </p>
      </div>
    </Modal>
  )
}

export default DeleteConfirmModal
